<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong><em>The Nonverbal Advantage</em></strong></h1>
<p class="subtitle"><strong><em>Secrets and Science of<br/>Body Language at Work</em></strong></p>
<p class="author"><strong><em>Carol Kinsey Goman</em></strong></p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?ed10dfba